"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _creatable = _interopRequireDefault(require("react-select/creatable"));

var _polished = require("polished");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  .flexi-select-option-element-label {\n    display: grid;\n    grid-template-columns: ", " auto ", ";\n    width: 100%;\n    line-height: 20px;\n    & div {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      font-weight: 600;\n    }\n    & i {\n      display: flex;\n      width: 25px;\n      height: 20px;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n  .flexi-select-option-element-subtext {\n    font-size: 0.8em;\n    opacity: 0.8;\n  }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n            content: \"*\";\n            color: ", ";\n            position: absolute;\n            top: -2px;\n            margin-left: 2px;\n          "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n      text-transform: none;\n      "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n            &:after {\n              position: absolute;\n              content: \"\\2713\";\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              background-color: ", ";\n              box-shadow: 0 1px 3px\n                ", ";\n              color: #fff;\n              border-radius: 50%;\n              transform: scale(0);\n              height: ", "px;\n              width: ", "px;\n              top: ", "px;\n              right: ", "px;\n              animation-name: ", ";\n              animation-duration: 0.3s;\n              animation-timing-function: cubic-bezier(0.51, 0.32, 0.85, 1.55);\n              animation-direction: forwards;\n              animation-iteration-count: 1;\n              animation-fill-mode: forwards;\n            }\n          "], ["\n            &:after {\n              position: absolute;\n              content: \"\\\\2713\";\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              background-color: ", ";\n              box-shadow: 0 1px 3px\n                ", ";\n              color: #fff;\n              border-radius: 50%;\n              transform: scale(0);\n              height: ", "px;\n              width: ", "px;\n              top: ", "px;\n              right: ", "px;\n              animation-name: ", ";\n              animation-duration: 0.3s;\n              animation-timing-function: cubic-bezier(0.51, 0.32, 0.85, 1.55);\n              animation-direction: forwards;\n              animation-iteration-count: 1;\n              animation-fill-mode: forwards;\n            }\n          "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n            border: 1px solid ", ";\n            box-shadow: 0 0 2px ", ";\n          "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n        display: flex;\n        width: 100%;\n      "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        margin-bottom: ", ";\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        margin-top: ", ";\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        margin-right: ", ";\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        margin-left: ", ";\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display: inline-flex;\n    align-items: center;\n    position: relative;\n    vertical-align:top;\n    /* font-smooth: auto; */\n    cursor: pointer;\n    min-height: ", "px;\n    width: ", "px;\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n\n  &>div{\n    min-height: inherit;\n    display: block;\n    width: 100%;\n\n    & .flexi__control{\n        width: 100%;\n        border-radius: ", ";\n        border: 1px solid ", ";\n        min-height: inherit;\n        display: grid;\n        /* z-index: 2; */\n        grid-template-columns: calc(100% - ", "px) minmax(max-content, ", "px);\n\n        & .flexi__value-container{\n          display: flex;\n          align-items: center;\n          & .flexi__placeholder{\n            display: flex;\n            align-items: center;\n            height: ", "px;\n          }\n          & .flexi__single-value{\n            font-weight: 500;\n            width: 100%;\n            & .flexi-select-option-element-subtext{\n              display: none;\n            }\n          }\n          &.flexi__value-container--is-multi{\n            padding: ", "px 10px;\n            & .flexi__multi-value{\n              height: ", "px;\n              border-radius: ", "px;\n              background: ", ";\n\n              & .flexi__multi-value__label{\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                color: ", ";\n                padding: 0 10px;\n              }\n              & .flexi__multi-value__remove{\n                border-radius: ", "px;\n                width: ", "px;\n                height: ", "px;\n                margin-top: ", "px;\n                margin-right: ", "px;\n                display: inline-flex;\n                align-items: center;\n                justify-content: center;\n                color: ", ";\n                cursor: pointer;\n                transition: ", ";\n                background: ", ";\n                &:hover{\n                  background: ", ";\n                  color: #fff;\n                }\n              }\n            }\n          }\n        }\n        & .flexi__indicators{\n          display: flex;\n          align-items: flex-end;\n          justify-content: center;\n          width: ", "px;\n          height: 100%;\n          & .flexi__indicator-separator{\n            display: none;\n          }\n          & .flexi__indicator{\n            border-radius: ", ";\n            background: ", ";\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            padding:0;\n            width: ", "px;\n            height: ", "px;\n            margin-bottom: 2px;\n            & svg{\n            width: ", ";\n            transition: ", ";\n            fill: ", ";\n            }\n          }\n        }\n\n        &.flexi__control--is-focused{\n          outline: none;\n          border: 1px solid ", ";\n          ", ";\n          & .flexi__indicator{\n\n          }\n        }\n        &.flexi__control--menu-is-open{\n          ", ";\n          & .flexi__indicator{\n            &.flexi__dropdown-indicator{\n            & svg{\n              transform: rotateZ(180deg);\n              fill: ", ";\n            }\n            }\n          }\n        }\n        &.flexi__control--is-disabled{\n          border: 1px dashed ", ";\n        }\n        ", "\n\n        ", "\n    }\n    & .flexi__menu{\n      padding: 0;\n      z-index: 5;\n      border-radius: ", ";\n      border: 1px solid ", ";\n      ", ";\n      & .flexi__menu-list{\n        padding:0;\n        & .flexi__option{\n          min-height: ", "px;\n          display: grid;\n          align-items: center;\n          &:hover,:active{\n            background-color: ", ";\n          }\n          &.flexi__option--is-focused{\n            background-color: ", ";\n          }\n          &.flexi__option--is-selected{\n            background-color: ", ";\n            font-weight: 500;\n          }\n        }\n      }\n    }\n  }\n    & .flexi-select-label{\n      position: absolute;\n      display: block;\n      top: -20px;\n      text-transform: uppercase;\n      ", "\n      font-weight: 700;\n      font-size: 0.9em;\n      cursor: default;\n\n      &::after {\n        ", ";\n      }\n    }\n    \n    & .flexi-select-error{\n      position: absolute;\n      display: block;\n      top: 110%;\n      color: ", ";\n      font-size: 0.9em;\n      font-style: italic;\n      left: 0;\n      cursor: default;\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n100%{\n  transform: scale(1);\n}"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Grow = (0, _styledComponents.keyframes)(_templateObject());
var SelectWrapper = (0, _styledComponents["default"])("div").attrs({
  className: "flexi-select"
})(_templateObject2(), function (props) {
  return props.height;
}, function (props) {
  return props.width;
}, function (props) {
  return props.spaceLeft && (0, _styledComponents.css)(_templateObject3(), function (props) {
    return props.spaceLeft.length >= 3 ? props.spaceLeft : "10px";
  });
}, function (props) {
  return props.spaceRight && (0, _styledComponents.css)(_templateObject4(), function (props) {
    return props.spaceRight.length >= 3 ? props.spaceRight : "10px";
  });
}, function (props) {
  return props.spaceTop && (0, _styledComponents.css)(_templateObject5(), function (props) {
    return props.spaceTop.length >= 3 ? props.spaceTop : "20px";
  });
}, function (props) {
  return props.spaceBottom && (0, _styledComponents.css)(_templateObject6(), function (props) {
    return props.spaceBottom.length >= 3 ? props.spaceBottom : "25px";
  });
}, function (props) {
  return props.block && (0, _styledComponents.css)(_templateObject7());
}, function (props) {
  return props.theme.PrimaryRadius;
}, function (props) {
  return props.borderColor ? props.borderColor : props.theme.PrimaryBorderColor;
}, function (props) {
  return props.height;
}, function (props) {
  return props.height;
}, function (props) {
  return props.height;
}, function (props) {
  return props.height * 0.2;
}, function (props) {
  return props.height * 0.6;
}, function (props) {
  return props.height * 0.6 / 2;
}, function (props) {
  return (0, _polished.transparentize)(0.8, props.color ? props.color : props.theme.PrimaryColor);
}, function (props) {
  return (0, _polished.darken)(0.2, props.color ? props.color : props.theme.PrimaryColor);
}, function (props) {
  return props.height * 0.5 / 2;
}, function (props) {
  return props.height * 0.5;
}, function (props) {
  return props.height * 0.5;
}, function (props) {
  return props.height * 0.05;
}, function (props) {
  return props.height * 0.05;
}, function (props) {
  return (0, _polished.transparentize)(0.2, props.color ? props.color : props.theme.PrimaryColor);
}, function (props) {
  return props.theme.PrimaryTransition;
}, function (props) {
  return (0, _polished.transparentize)(0.9, props.color ? props.color : props.theme.PrimaryColor);
}, function (props) {
  return (0, _polished.transparentize)(0.2, props.color ? props.color : props.theme.PrimaryColor);
}, function (props) {
  return props.height;
}, function (props) {
  return props.theme.PrimaryRadius;
}, function (props) {
  return props.caretBg;
}, function (props) {
  return props.height - 4;
}, function (props) {
  return props.height - 6;
}, function (props) {
  return props.theme.PrimaryFontSize;
}, function (props) {
  return props.theme.PrimaryTransition;
}, function (props) {
  return (0, _polished.darken)(0.2, props.borderColor ? props.borderColor : props.theme.PrimaryBorderColor);
}, function (props) {
  return (0, _polished.darken)(0.1, props.borderColor ? props.borderColor : props.theme.PrimaryBorderColor);
}, function (props) {
  return props.theme.Elevate.low;
}, function (props) {
  return props.theme.Elevate.low;
}, function (props) {
  return (0, _polished.darken)(0.3, props.borderColor ? props.borderColor : props.theme.PrimaryBorderColor);
}, function (props) {
  return (0, _polished.transparentize)(0.1, props.borderColor ? props.borderColor : props.theme.PrimaryBorderColor);
}, function (props) {
  return props.error && (0, _styledComponents.css)(_templateObject8(), function (props) {
    return props.theme.PrimaryRed;
  }, function (props) {
    return props.theme.PrimaryRed;
  });
}, function (props) {
  return props.valid && (0, _styledComponents.css)(_templateObject9(), function (props) {
    return props.theme.PrimaryGreen;
  }, function (props) {
    return (0, _polished.transparentize)(0.5, props.theme.PrimaryGreen);
  }, function (props) {
    return props.height * 0.4;
  }, function (props) {
    return props.height * 0.4;
  }, function (props) {
    return props.height * 0.3;
  }, function (props) {
    return props.height * 0.3;
  }, Grow);
}, function (props) {
  return props.theme.PrimaryRadius;
}, function (props) {
  return (0, _polished.darken)(0.1, props.borderColor ? props.borderColor : props.theme.PrimaryBorderColor);
}, function (props) {
  return props.theme.Elevate.fader;
}, function (props) {
  return props.height - 8;
}, function (props) {
  return (0, _polished.transparentize)(0.4, props.borderColor ? props.borderColor : props.theme.PrimaryBorderColor);
}, function (props) {
  return (0, _polished.transparentize)(0.4, props.borderColor ? props.borderColor : props.theme.PrimaryBorderColor);
}, function (props) {
  return props.color ? props.color : props.theme.PrimaryColor;
}, function (props) {
  return props.theme.noLabelUpperCase && (0, _styledComponents.css)(_templateObject10());
}, function (_ref) {
  var required = _ref.required,
      theme = _ref.theme;
  return required && (0, _styledComponents.css)(_templateObject11(), theme.PrimaryRed);
}, function (props) {
  return props.theme.PrimaryRed;
});
var ElementOptionWrapper = (0, _styledComponents["default"])("div").attrs({
  className: "flexi-select-option-element"
})(_templateObject12(), function (props) {
  return props.iconLeft && "25px";
}, function (props) {
  return props.iconRight && "25px";
});

var ElementOption = function ElementOption(props) {
  return /*#__PURE__*/_react["default"].createElement(ElementOptionWrapper, props, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flexi-select-option-element-label"
  }, props.iconLeft && /*#__PURE__*/_react["default"].createElement("i", {
    className: props.iconLeft
  }), /*#__PURE__*/_react["default"].createElement("div", null, props.label), props.iconRight && /*#__PURE__*/_react["default"].createElement("i", {
    className: props.iconRight
  })), props.subText && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flexi-select-option-element-subtext"
  }, props.subText));
};

var Select = function Select(props) {
  var Options = props.options;
  Options = props.simpleOptions ? props.simpleOptions.map(function (elem) {
    return {
      value: elem,
      label: elem
    };
  }) : Options;
  Options = props.elementOptions ? props.elementOptions.map(function (elem) {
    return {
      value: elem.label,
      label: /*#__PURE__*/_react["default"].createElement(ElementOption, elem)
    };
  }) : Options;
  return /*#__PURE__*/_react["default"].createElement(SelectWrapper, props, props.label && /*#__PURE__*/_react["default"].createElement("span", {
    className: "flexi-select-label"
  }, props.label), props.creatable ? /*#__PURE__*/_react["default"].createElement(_creatable["default"], _extends({}, props, {
    classNamePrefix: "flexi",
    isDisabled: props.disable,
    options: Options
  })) : /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], _extends({}, props, {
    classNamePrefix: "flexi",
    isDisabled: props.disable,
    options: Options
  })), props.error && /*#__PURE__*/_react["default"].createElement("span", {
    className: "flexi-select-error"
  }, props.error));
};

exports.Select = Select;
Select.defaultProps = {
  block: false,
  caretBg: "none",
  spaceLeft: false,
  spaceRight: false,
  height: 42,
  width: 180,
  elevate: false,
  pale: false
};
Select.propTypes = {
  block: _propTypes["default"].bool,
  caretBg: _propTypes["default"].string,
  color: _propTypes["default"].string,
  spaceLeft: _propTypes["default"].any,
  spaceRight: _propTypes["default"].any,
  spaceTop: _propTypes["default"].any,
  spaceBottom: _propTypes["default"].any,
  height: _propTypes["default"].number,
  fontColor: _propTypes["default"].string,
  elevate: _propTypes["default"].any,
  pale: _propTypes["default"].bool,
  width: _propTypes["default"].number,
  disable: _propTypes["default"].bool,
  error: _propTypes["default"].any,
  valid: _propTypes["default"].bool,
  simpleOptions: _propTypes["default"].array,
  elementOptions: _propTypes["default"].any,
  label: _propTypes["default"].any
};